import { usePageTrack } from '@v2/services/analytics.service';
import { LinkWithReferrer } from '@components/common/helpers/link';

import { css } from '@emotion/css'
import colors from '@v2/styles/colors';

const style = css({
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 80,

    h1: {
        textAlign: 'center',
        marginBottom: 10,
        maxWidth: 600,
    },
    h3: {
        textAlign: 'center',
        marginBottom: 25,
        color: colors.BLUE,
        maxWidth: 600,
    },
    a: {
        color: `${colors.RED} !important`
    }

});

export default function NotFoundPage() {
    usePageTrack('Cerebelly - 404');

    return (
        <div className={style}>
            <h1>Sorry, that page does not exist.</h1>
            <h3>Are you looking for our baby food purees and smart bars?</h3>
            <LinkWithReferrer to={'/'} className="button link secondary">
                Back to homepage
            </LinkWithReferrer>
        </div>
    );
}